import {
  Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ElementRef, AfterContentChecked, Renderer2, HostListener
} from '@angular/core';

import { Observable } from 'rxjs';

import { Devicetype } from '../../../models/imports/generic';
import { DataService } from '../../../services/data.service';
import { WindowService } from '../../../services/window-service';
import Dots from '../../../utils/helpers/dots';
import { Controltype, Vraag, Vraagtype } from '@models/claims';
import { VraagboomAntwoord, IBaseVraagboomResultaat } from '@models/vragenboom';
import { VraagHelper } from '@services/public_api';
import { takeUntil } from 'rxjs/operators';
import { BaseOlsControlDirective } from '../../base/base-ols-control';

@Component({
  selector: 'app-vraag-control',
  templateUrl: './vraag-control.component.html',
  styleUrls: ['./vraag-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VraagControlComponent extends BaseOlsControlDirective implements OnInit, AfterContentChecked {
  @Input() vraag: Vraag;
  @Input() isCurrentVraag: boolean;
  @Output() antwoordResultaatChange: EventEmitter<VraagboomAntwoord<IBaseVraagboomResultaat>>
    = new EventEmitter<VraagboomAntwoord<IBaseVraagboomResultaat>>();
  _antwoordResultaat: VraagboomAntwoord<IBaseVraagboomResultaat>;
  @Input()
  get antwoordResultaat(): VraagboomAntwoord<IBaseVraagboomResultaat> {
    return this._antwoordResultaat;
  }
  set antwoordResultaat(val: VraagboomAntwoord<IBaseVraagboomResultaat>) {
    this._antwoordResultaat = val;
  }
  private controltype = Controltype;
  private vraagtype = Vraagtype;
  dots: any;
  lineClampAanw: boolean;
  maxHeight: number;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  alleResultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];
  ietjeTonen: boolean;
  vraagtitelTonen: boolean;
  vraagClass: string[];

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private _dataService: DataService,
    private _windowService: WindowService) { super(); }

  get nativeElement(): HTMLInputElement {
    return this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.setMaxHeight();
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.alleResultaten = res;
        }
      });
    this.vraagtitelTonen = this.vraag.control !== Controltype.Info && this.vraag.control !== Controltype.MobielSchadeMelden && this.vraag.control !== Controltype.Succes && this.vraag.control !== Controltype.SuccesVerder && this.vraag.control !== Controltype.SuccesFutureState && !(this.vraag.control === Controltype.Failure && this.vraag.vraagtype === Vraagtype.OnlineNietMogelijk);
    this.ietjeTonen = this.vraag.control !== Controltype.MobielSchadeMelden && (this.vraag.control === Controltype.Failure && !(this.vraag.vraagtype === Vraagtype.OnlineNietMogelijk || this.vraag.vraagtype === Vraagtype.VerzekeringNietAfgesloten))
      || (this.vraag.control === Controltype.Succes && this.vraag.vraagtype !== Vraagtype.Telefoon)
      || (this.vraag.control === Controltype.Ruithersteller)
      || (this.vraag.control === Controltype.SuccesFutureState);
    this.vraagClass = this.getVraagClass();
  }

  ngAfterContentChecked() {
    this.lineClamp();
  }

  geefTitel(vraag: Vraag): string {
    return VraagHelper.geefTitel(vraag.titel, this.alleResultaten);
  }

  onAntwoordResultaatChange(resultaat: VraagboomAntwoord<IBaseVraagboomResultaat>) {
    this.antwoordResultaatChange.emit(resultaat);
  }

  lineClamp() {
    const lineclamp = this.elementRef.nativeElement.querySelector('#line-clamp') as HTMLElement;

    if (lineclamp) {
      this.lineClampAanw = true;

      if (lineclamp.scrollHeight > this.maxHeight) {
        this.renderer.addClass(this.elementRef.nativeElement.querySelector('.lees-meer'), 'show');

        if (this.dots === undefined) {
          this.dots = new Dots(lineclamp, {
            height: this.maxHeight,
            keep: '.lees-meer'
          });

          this.setEventMeer();
        } else {
          if (this.dots.options.height !== this.maxHeight) {
            this.dots.options.height = this.maxHeight;
          }
          this.setEventMeer();
          this.setEventMinder();
        }
      } else {
        this.renderer.removeClass(this.elementRef.nativeElement.querySelector('.lees-meer'), 'show');
        this.renderer.removeClass(this.elementRef.nativeElement.querySelector('#line-clamp'), 'untrunc');
      }
    }
  }

  setEventMeer() {
    if (document.querySelector('.lees-meer')) {
      document.querySelector('.lees-meer').addEventListener('click', (evnt) => {
        evnt.preventDefault();
        this.renderer.addClass(this.elementRef.nativeElement.querySelector('#line-clamp'), 'untrunc');
        this.dots.API.restore();
      });
    }
  }

  setEventMinder() {
    if (document.querySelector('.lees-minder')) {
      document.querySelector('.lees-minder').addEventListener('click', (evnt) => {
        evnt.preventDefault();
        this.renderer.removeClass(this.elementRef.nativeElement.querySelector('#line-clamp'), 'untrunc');
        this.dots.API.truncate();
        this.setEventMeer();
      });
    }
  }

  setMaxHeight() {
    const lineheight = 24;
    let numberOfLines = 2;
    if (this._windowService.deviceType() <= Devicetype.TabletPortrait) {
      numberOfLines = 3;
    }
    this.maxHeight = numberOfLines * lineheight;
  }

  getVraagClass(): string[] {
    var classes: string[] = [
      `ols-${this.vraag.control}`,
      `ols-${this.vraag.vraagtype}`];
    if (this.ietjeTonen) {
      classes.push('ols-ietje');
    }

    this.vraag.styles?.forEach(style => classes.push(`ols-${style}`));
    return classes;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.lineClampAanw) {
      this.setMaxHeight();
      if (this.dots && this.dots.options.height !== this.maxHeight) {
        this.dots.options.height = this.maxHeight;
      }
      this.lineClamp();
    }
  }
}
